import {ActivityReview} from '@/containers'
import {ProgressIndicator, HeaderTitle, Breadcrumb} from '@/components/atoms'

const AddActivityReview = () => {
  return (
    <>
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: [
            {
              href: '/',
              label: '',
            },

            {
              href: '',
              label: 'Add Activity Mexico',
            },
          ],
        }}
        id={'aar_bradcrumb'}
      />
      <HeaderTitle title={'Activity Review'} className="mb-3 justify-start text-3xl font-bold text-slate-200" />
      <ProgressIndicator
        currentStep={2}
        completed={false}
        steps={2}
        titles={[{title: 'Setup'}, {title: 'Review'}]}
        className="mb-6"
      />
      <br />
      <ActivityReview />
    </>
  )
}

export default AddActivityReview
